import { NgModule } from '@angular/core';

import { AuthUsersRoutingModule } from './auth-users-routing.module';
import { AuthenticationService } from '@core/services/authentication.serivce';

import { AuthUserListComponent } from './auth-user-list/auth-user-list.component';
import { AuthUserComponent } from './auth-user/auth-user.component';
import { DetailComponent } from '../../shared/components/detail/detail.component';
import { SearchComponent } from '../../shared/components/search/search.component';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { CommonModule } from '@angular/common';
import { AuthUserService } from './services/auth-user.service';

@NgModule({
  imports: [
    DetailComponent,
    LayoutModule,
    CommonModule,
    SearchComponent,
    AuthUsersRoutingModule
  ],
  declarations: [
    AuthUserListComponent,
    AuthUserComponent
  ],
  providers: [AuthenticationService, AuthUserService]
})
export class AuthUsersModule { }
